import { Link } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { PageHero, EmptyState } from '@/components/PagePlaceholder';
import { PosterCard } from '@/components/Poster';
import { buttonVariants } from '@/components/ui/Button';
import { ListVideo, X } from '@/components/icons';
import { meApi } from '@/features/catalog/api';

export function MyListPage() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ['my-list'], queryFn: meApi.list });
  const remove = useMutation({
    mutationFn: (showId: string) => meApi.removeFromList(showId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['my-list'] }),
  });

  const shows = data?.shows ?? [];

  return (
    <div>
      <PageHero eyebrow="My List" title="Everything you've saved." />
      <div className="container-page pb-16">
        {isLoading ? (
          <p className="text-sm text-ink-faint">Loading…</p>
        ) : shows.length === 0 ? (
          <EmptyState
            icon={<ListVideo size={26} strokeWidth={1.75} />}
            title="Your list is empty"
            description="Add shows to your list from any show page and they'll show up here."
            action={
              <Link to="/browse" className={buttonVariants({ variant: 'primary', size: 'md' })}>
                Browse shows
              </Link>
            }
          />
        ) : (
          <div className="flex flex-wrap gap-3">
            {shows.map((s) => (
              <PosterCard
                key={s.id}
                show={s}
                action={
                  <button
                    type="button"
                    aria-label={`Remove ${s.title} from My List`}
                    onClick={() => remove.mutate(s.id)}
                    className="grid h-8 w-8 place-items-center rounded-full bg-bg/80 text-ink-muted backdrop-blur transition-colors hover:text-ink"
                  >
                    <X size={16} />
                  </button>
                }
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
